import { Token } from "../token/token";
import { BASEURL } from "../../../environments/environment";

declare var window: any;

export interface AuthTokenParams {
  access_token: string;
  expires_in: number;
  token_type: string;
  refresh_token?: string;
}

/** Parse OAuth token params from a URL hash fragment or query string. */
export const parseAuthTokenParamString = (paramString: string): AuthTokenParams => {
  const stripped = (paramString ?? '').replace(/^[#?]+/, '');
  // Encode + as %2B so URLSearchParams doesn't convert it to a space
  const params = new URLSearchParams(stripped.replace(/\+/g, '%2B'));

  const rawExpiresIn = Number(params.get('expires_in'));
  const rawRefreshToken = params.get('refresh_token');

  return {
    access_token: params.get('access_token') ?? '',
    expires_in: Number.isNaN(rawExpiresIn) ? 0 : rawExpiresIn,
    token_type: params.get('token_type') ?? '',
    ...(rawRefreshToken != null ? { refresh_token: rawRefreshToken } : {}),
  };
};

/**
 * @deprecated Use parseAuthTokenParamString instead
 */
export function parseUrlHash(urlString: string): Token {
  urlString = urlString.replace("#", "");
  const pairs = urlString.split("&");
  const result = new Token();
  if (urlString !== "") {
    pairs.forEach((pair: string) => {
      const pairArr = pair.split("=");
      (result as any)[pairArr[0]] = decodeURIComponent(pairArr[1] || "");
    });
  }
  return result;
}

export interface RiskEvaluation {
  status: string | null;
  hasActiveCreditLimit: boolean;
  riskCode?: string;
  shouldTrackWebEngage: boolean;
}

export function evaluateRiskResponse(
  statusCode: string,
  result: unknown,
  commsCode: number,
): RiskEvaluation {
  if (statusCode === "ZMRSK200" && result) {
    return {
      status:
        [6, 7, 8, 9, 10].indexOf(commsCode) !== -1 ? "Blocked" : "Active",
      hasActiveCreditLimit: true,
      shouldTrackWebEngage: false,
    };
  }
  if (statusCode === "ZMRSK402" && !result)
    return { status: "Utilized", hasActiveCreditLimit: true, shouldTrackWebEngage: false };
  if (statusCode === "ZMRSK400" && result === null)
    return { status: "Approved", hasActiveCreditLimit: true, shouldTrackWebEngage: false };
  if (statusCode === "ZMRSK408" && !result)
    return { status: "Expired", hasActiveCreditLimit: true, shouldTrackWebEngage: false };
  if (
    (statusCode === "ZMRSK704" ||
      statusCode === "ZMRSK947" ||
      statusCode === "ZMRSK946") &&
    !result
  ) {
    return {
      status: "Blocked",
      hasActiveCreditLimit: true,
      riskCode: statusCode,
      shouldTrackWebEngage: false,
    };
  }
  return { status: null, hasActiveCreditLimit: false, shouldTrackWebEngage: true };
}

interface BoltTokenService {
  getToken: () => unknown;
  sendDataToPaymentApp: (key: string, value: unknown) => void;
  checkTokenAcknowledgementFromPaymentApp: () => string | null;
}

export function redirectBoltCustomer(tokenSvc: BoltTokenService) {
  const token = tokenSvc.getToken();
  tokenSvc.sendDataToPaymentApp("zest-bolt-customer", true);
  tokenSvc.sendDataToPaymentApp("token", token);
  let counter = 0;
  const interval = setInterval(() => {
    if (tokenSvc.checkTokenAcknowledgementFromPaymentApp()) {
      clearInterval(interval);
      window.location.href = BASEURL + "/features/bolt";
    } else {
      counter++;
    }
    if (counter === 10) {
      clearInterval(interval);
      window.location.href = BASEURL + "/error/404";
    }
  }, 300);
}
